import { JsonApiModel } from 'pf-frontend-common/src/module/json-api/model';

export class PropertyReportModel extends JsonApiModel {
  /**
   * @inheritDoc
   */
  public static readonly JSONAPI_TYPE: string = 'property_report';

  /**
   * @inheritDoc
   */
  public jsonApiType: string = PropertyReportModel.JSONAPI_TYPE;

  /**
   * @inheritDoc
   */
  public jsonApiAttributes: Array<keyof PropertyReportModel> = [
    'email',
    'user_phone',
    'reason_id',
    'message',
    'reporter_type',
    'captcha_token',
  ];

  /**
   * @inheritDoc
   */
  public jsonApiRelationships: Array<keyof PropertyReportModel> = [];

  /**
   * Email
   */
  public email: string = '';

  public user_phone?: string = '';

  /**
   * Message
   */
  public message: string = '';

  // tslint:disable:variable-name

  /**
   * Reason
   */
  public reason_id: number;

  /**
   * Captcha token
   */
  public captcha_token: string;

  /**
   * Reporter type
   */
  public reporter_type: string;

  // tslint:enable:variable-name
}
